<template>
<div>

	<main-header></main-header>

	<div class="container-fluid">

		<div class="row">

			<div class="col mt-5">

				<router-view></router-view>

			</div>

		</div>

	</div>

</div>
</template>

<script>
import MainHeader from '@/components/layouts/includes/MainHeader'

export default {
	components: {
		MainHeader
	},
	data() {
		return {
			message: 'Dashboard'
		}
	}
}
</script>



// WEBPACK FOOTER //
// LiveAuctionLayout.vue?8c768d36